import React, { Component } from 'react';
import { Box } from '@mui/material';

import { TraySettings } from '@paragon/contract-library';
import { DistanceField } from '@paragon/material';

import { InteriorConditionSettingsPropertiesProps } from './InteriorConditionSettingsPropertiesProps';

type Props = InteriorConditionSettingsPropertiesProps<TraySettings>;

export class TraySettingsProperties extends Component<Props> {
  createSubmitHandler =
    <K extends keyof TraySettings>(key: K) =>
    (value: TraySettings[K]) => {
      this.props.onChange({ ...this.props.value, [key]: value });
    };

  render() {
    const { value } = this.props;

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <DistanceField
            sx={[value.distanceFromLeft === 0 ? { m: 1, fieldSet: { borderColor: 'brand.orange' } } : { m: 1 }]}
            label="Distance From Left"
            value={value.distanceFromLeft}
            onSubmit={this.createSubmitHandler('distanceFromLeft')}
          />

          <DistanceField
            sx={{ m: 1 }}
            label="Step Up Distance"
            value={value.stepUp}
            onSubmit={this.createSubmitHandler('stepUp')}
          />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <DistanceField
            sx={{ m: 1 }}
            label="Tray Width"
            value={value.trayWidth}
            onSubmit={this.createSubmitHandler('trayWidth')}
          />

          <DistanceField
            sx={{ m: 1 }}
            label="Step Down Distance"
            value={value.stepDown}
            onSubmit={this.createSubmitHandler('stepDown')}
          />
        </Box>
      </Box>
    );
  }
}
